// extracted by mini-css-extract-plugin
export default {"container":"proyects_container__sgSHF","proyects":"proyects_proyects__I9YjH","subrayado":"proyects_subrayado__doPWS","cardContainer":"proyects_cardContainer__RLwVo"};